import { getBackendUrl } from '@/lib/backendUrl';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { ArrowRight } from 'lucide-react';
import { toast } from 'sonner';

const API = getBackendUrl();

function authHeaders() {
  const t = localStorage.getItem('access_token');
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export default function ChangeHistoryDialog({ mappingKind, sourceKey, onClose }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    axios.get(`${API}/api/sales-invoicing/workbench/${mappingKind}/history/${encodeURIComponent(sourceKey)}`, { headers: authHeaders() })
      .then(({ data }) => setHistory(data.history || []))
      .catch((err) => {
        setLoadError(true);
        toast.error(err.response?.data?.detail || 'Could not load the change history.');
      })
      .finally(() => setLoading(false));
  }, [mappingKind, sourceKey]);

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent data-testid="change-history-dialog">
        <DialogHeader>
          <DialogTitle>Change history</DialogTitle>
        </DialogHeader>
        {loading && <div className="text-sm text-slate-500">Loading…</div>}
        {!loading && loadError && <div className="text-sm text-red-600" data-testid="change-history-error">Could not load the change history — try again.</div>}
        {!loading && !loadError && history.length === 0 && <div className="text-sm text-slate-500" data-testid="change-history-empty">No changes recorded yet.</div>}
        <div className="space-y-2 max-h-80 overflow-y-auto" data-testid="change-history-list">
          {history.map((h, idx) => (
            <div key={idx} className="text-sm border rounded-md p-2 flex items-center justify-between" data-testid={`change-history-row-${idx}`}>
              <div className="flex items-center gap-2">
                <span className="text-slate-400">{h.old_reference_name || '— none —'}</span>
                <ArrowRight className="h-3 w-3 text-slate-400" />
                <span className="font-medium">{h.new_reference_name || '— none —'}</span>
              </div>
              <div className="text-xs text-slate-400 text-right">
                {h.changed_by || 'Unknown'}<br />{new Date(h.changed_at).toLocaleString()}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
